<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter11">
<h1><a id="page_29"></a><a href="#/003toc#ch11">Roasted Tomato Soup with Spinach Pesto</a></h1>
<p class="noindent">Roasting tomatoes in the slow cooker intensifies their flavor and gives them a whole new personality. Flavored with aromatic herbs and garlic and simmered with chicken broth, ricotta, and Parmigiano cheese, this soup is sure to please even the fussiest eaters. If that isn’t enough, a dollop of garlicky spinach pesto tops it all off! This soup is another candidate for that grown-up grilled cheese sandwich, the panini, or accompanied with bruschetta.</p>
<h3 class="left"><span class="uppercase">SOUP</span></h3>
<p class="noindent">Two 28-ounce cans peeled whole tomatoes, drained</p>
<p class="noindent">½ cup extra-virgin olive oil</p>
<p class="noindent">2 teaspoons dried basil</p>
<p class="noindent">1 teaspoon dried marjoram</p>
<p class="noindent">½ cup chopped red onion</p>
<p class="noindent">6 cloves garlic, coarsely chopped</p>
<p class="noindent">1½ teaspoons salt</p>
<p class="noindent">Pinch red pepper flakes</p>
<p class="noindent">½ cup vegetable or chicken broth</p>
<p class="noindent">1 cup whole-milk ricotta cheese</p>
<p class="noindent">1½ cups heavy cream</p>
<p class="noindent">½ cup freshly grated Parmigiano-Reggiano</p>
<p class="noindent">Spinach Pesto (recipe follows)</p>
<h3 class="left"><span class="uppercase">SPINACH PESTO</span></h3>
<p class="noindent">Two 10-ounce packages baby spinach</p>
<p class="noindent">½ cup pine nuts</p>
<p class="noindent">2 cloves garlic, peeled</p>
<p class="noindent">Grated zest of 1 lemon</p>
<p class="noindent">½ cup packed fresh basil leaves</p>
<p class="noindent">½ cup freshly grated Parmesan cheese</p>
<p class="noindent"><sup>2</sup>/<sub>3</sub> cup olive oil</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">combine the tomatoes, olive oil, basil, marjoram, onion, garlic, salt, pepper flakes, and broth in the insert of a 5- to 7-quart slow cooker.</p>
<p class="noindent">cover the slow cooker and cook on low for 6 hours, until the tomatoes and onion are softened. Using an immersion blender, purée the soup, or cool the soup and purée it in a blender or food processor. Whisk in the ricotta, cream, and Parmigiano-Reggiano.</p>
<p class="noindent">cover the cooker and turn it to warm. Allow the soup to come to serving temperature (the retained heat in the cooker will heat the cheese and cream, without it separating).</p>
<p class="noindent">serve the soup garnished with the spinach pesto.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="noindent">Spinach pesto retains its bright green color and adds zip and color to roasted tomato soup, but it can also be tossed with pasta or as a sauce for pasta or potato salad.</p>
<p class="noindent">put the spinach, pine nuts, garlic, lemon zest, basil, and Parmesan cheese in the work bowl of a food processor or a blender. Pulse the food processor on and off until the leaves are chopped and the mixture is chunky. With the machine running, slowly pour in the oil and process until the mixture comes together.</p>
<p class="noindent">season with salt and pepper. Store the pesto, covered, in the refrigerator for up to 1 week or in the freezer for up to 6 weeks.</p>
<p class="noindent">makes about 3 cups</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 017-chapter11.vue?e93cbe8e